const BotType = {
    PREPAID: "PREPAID",
    POSTPAID: "POSTPAID",
    PAYMENTS_BANK: "PAYMENTSBANK",
    SIEBEL: "SIEBEL",
    getNumberTypeToShow: function (type) {
        if (type) {
            switch (type) {
                case BotType.SIEBEL:
                    return 'POSTPAID'
                default:
                    return type
            }
        }
        else {
            return ''
        }
    }
}

export default BotType;


// WEBPACK FOOTER //
// ./src/enums/BotType.js